import { Trans, useTranslation } from "react-i18next";
import { Heading, Text } from "@ttc3k/trekker";
import { Flex, styled } from "styled-system/jsx";
import { useOnboardingContext } from "onboarding/OnboardingContext.tsx";

export const ComingSoonScreen = () => {
  const { t } = useTranslation("onboarding", {
    keyPrefix: "COMING_SOON_SCREEN",
  });
  const { organization } = useOnboardingContext();
  return (
    <Flex flexDir={"column"} gap={"150"} alignItems={"center"}>
      <Heading size={"h4"}>{t("TITLE")}</Heading>
      <Trans
        i18nKey={"onboarding:COMING_SOON_SCREEN.DESCRIPTION"}
        components={{
          Text: <Text textAlign={"center"} color={"text.mid"} />,
          Link: (
            <styled.a
              textDecoration={"underline"}
              href={`mailto:${organization?.contact?.email}`}
            />
          ),
        }}
      />
    </Flex>
  );
};
